// src/utils/excelExport.ts
import * as XLSX from 'xlsx';
import { appendPoweredByWorksheet } from '@/support/exportBranding';

export interface ExportArrayToExcelOptions {
  fileName?: string;  // Nom du fichier (par défaut: rapport.xlsx)
  sheetName?: string; // Nom de l’onglet (par défaut: Feuille1)
}

/**
 * Exporte un tableau d’objets JSON en fichier Excel.
 *
 * @param rows       Liste des lignes (tableau d’objets { colonne: valeur })
 * @param options    Options de nom de fichier et de feuille
 */
export function exportArrayToExcel<T extends Record<string, any>>(
  rows: T[],
  options: ExportArrayToExcelOptions = {}
): void {
  const { fileName = 'rapport.xlsx', sheetName = 'Feuille1' } = options;

  if (!rows || rows.length === 0) {
    // Tu peux remplacer par un toast global si tu préfères
    // eslint-disable-next-line no-alert
    alert('Aucune donnée à exporter.');
    return;
  }

  const worksheet = XLSX.utils.json_to_sheet(rows);
  appendPoweredByWorksheet(worksheet);
  const workbook = XLSX.utils.book_new();

  XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
  XLSX.writeFile(workbook, fileName);
}
